import { useEffect } from 'react';
import {
  getAllFiltersQueryParams,
  getToken,
  getUrl,
} from '@hotjar/webapp/features/Playbacks/store/utils';
import type { Store } from '@hotjar/recordings/src/store/player/types';

export const useCacheNextAndPreviousRecordingRequest = (store: Store, loaded: boolean): void => {
  const { recordingId, recordingsList, siteId, getRecordingIdByIndex, getRecordingIndexById } =
    store.getState();

  const fetchRecordingFunction = window.fetchRecording;

  useEffect(() => {
    if (!loaded || !fetchRecordingFunction || !recordingsList.length) {
      return;
    }

    const recordingIndex = getRecordingIndexById(recordingId);
    const previousRecordingId = getRecordingIdByIndex(recordingIndex - 1);
    const nextRecordingId = getRecordingIdByIndex(recordingIndex + 1);

    const url = getUrl();
    const token = getToken();
    const filtersQueryParams = getAllFiltersQueryParams();

    if (nextRecordingId) {
      fetchRecordingFunction(siteId, nextRecordingId, filtersQueryParams, token, url);
    }

    if (previousRecordingId) {
      fetchRecordingFunction(siteId, previousRecordingId, filtersQueryParams, token, url);
    }
  }, [
    loaded,
    fetchRecordingFunction,
    recordingId,
    recordingsList,
    siteId,
    getRecordingIndexById,
    getRecordingIdByIndex,
  ]);
};
